"use strict";
exports.__esModule = true;
exports.BasketStore = void 0;
var akita_1 = require("@datorama/akita");
var model_1 = require("../model");
var env_1 = require("../../../env");
var initialBasket = model_1.createBasket({}, env_1.Env.Currency);
exports.BasketStore = akita_1.createStore(initialBasket, { name: 'basket' });
//# sourceMappingURL=basket.store.js.map